import React, {useState} from "react";
import ExitButton from "../buttons/ExitButton";
import {sendOneNotifications} from "../set-date/setDateAction";
import {useDispatch} from "react-redux";
import styled from "styled-components";
import {BaseModalForm} from "./modalStyle";
import Checkbox from "../inputs/Checkbox";
import InputDeadline from "../inputs/InputDeadline";


const SetDateModal = ({title, id, setOpenModal}) => {

    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState({
        meetingDate: "",
        withTeam: false,
    })


    const [isSend, setIsSend] = useState(false)
    const [requestIsNotSend, setRequestIsNotSend] = useState(false)
    const [errorMessageEmptyDate, setErrorMessageEmptyDate] = useState(false)


    const handleChange = (e) => {
        const {type, name, value} = e.target
        if (type === "checkbox") {
            const isChecked = e.target.checked;
            setSelectedOption(prevState => ({
                ...prevState,
                [name]: isChecked
            }));

        }
        if (type === "date") {
            setSelectedOption(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    }

    const closeUpdate = () => {
        setOpenModal(false)
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        if (selectedOption.date === "") {
            setErrorMessageEmptyDate(true)
            return
        }
        try {
            await dispatch(sendOneNotifications(id, selectedOption))
            setIsSend(true)
            setTimeout(() => closeUpdate(), 1000)
        } catch {
            setRequestIsNotSend(true)
        }
    }

    return (
        <div className={"shadow"}>
            <Modal onSubmit={handleSubmit}>
                <FirstSection className={"flex-row"}>
                    <h2>  {title} </h2>
                    <ExitButton
                        closeUpdate={closeUpdate}
                    />
                </FirstSection>
                <Checkbox
                    title={"Faire la mise à jour avec l'équipe"}
                    id={id}
                    value={id}
                    name={"withTeam"}
                    handleChange={handleChange}
                />

                <InputDeadline
                    value={''}
                    label={''}
                    name={"meetingDate"}
                    handleChange={handleChange}
                />
                <Button type="submit">
                    <h6> Confirmer </h6>
                </Button>
                {errorMessageEmptyDate &&
                <p className={"error-text"}> Vous devez définir une date </p>
                }
                {isSend &&
                <p className={"success-text"}> Date envoyée </p>
                }
                {requestIsNotSend &&
                <p className={"error-text"}> Une erreur s'est produite </p>
                }
            </Modal>
        </div>
    )
}

export default SetDateModal;

const Modal = styled(BaseModalForm)`
  position: fixed;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  width: 300px;
  height: 250px;
  padding: 1em;

  @media (min-width: 600px) {
    inset: 0;
    margin: auto;
    width: 460px;
    height: 250px;
    h4 {
      text-align: center;
    }

    svg {
      width: 30px;
    }
  }
`
const FirstSection = styled.div`
  display: flex;
  align-items: flex-start;

  h2 {
    text-align: center;
    margin-bottom: 0.5em;
  }

  svg {
    transform: translate(50%, -50%);
  }
`

const Button = styled.button`
  border: none;
  box-shadow: 1px 1px 4px rgba(166, 172, 181, 0.6);
  width: 8em;
  height: 2.5em;
  background-color: var(--color-green);
  border-radius: 10px;

  h6 {
    color: var(--color-white);
  }

  &:hover {
    background-color: var(--color-green);
  }
`

